'use client';

import { Box } from '@mui/material';
import { useState } from 'react';
import { z } from 'zod';
import themeConstants from '@/components/theme/theme-constants';

export function ScrollPoint(props: z.input<typeof scrollPointSchema>) {
  const { id } = scrollPointSchema.parse(props);
  const [isTopLevelElement, setIsTopLevelElement] = useState(true);

  function handleSetIsTopLevelElement(element: HTMLSpanElement | null) {
    setIsTopLevelElement(element?.parentElement?.id === 'page-content-container');
  }

  return (
    <Box
      component="span"
      data-anchor={id}
      ref={handleSetIsTopLevelElement}
      sx={{
        // Adding 'inline' display style ensures negtative spacing is only applied to ScrollPoint component
        display: 'inline',
        // Adjust positioning to overlap with the next element if it's a top-level element (to compensate for the stack spacing)
        mb: isTopLevelElement ? -themeConstants.layout.pageContentSpacing : 0,
      }}
    />
  );
}

export const scrollPointSchema = z.object({
  id: z.string(),
});
